<template>
  <section class="login-wrapper">
    <div class="login">
      <header class="login__header">Вход в систему</header>
      <form class="login__form" @submit.prevent="onLogin">
        <p class="login__item">
          <input type="text" class="login__input" v-model="login" />
        </p>
        <p class="login__item">
          <input type="password" class="login__input" v-model="password" />
        </p>
        <p class="login__item">
          <input type="submit" value="Войти" class="login__button" />
        </p>
      </form>
    </div>
  </section>
</template>

<script>
import { AUTH_REQUEST } from "../../store/actions/auth";

export default {
  name: "Login",
  data() {
    return {
      login: "",
      password: ""
    };
  },
  methods: {
    onLogin() {
      const loginParams = {
        login: this.login,
        password: this.password
      };
      this.$store
        .dispatch(AUTH_REQUEST, loginParams)
        .then(() => this.$router.push("/"));
    }
  }
};
</script>

<style>
@import "./css/style.css";
</style>
